import { PLATFORM_ID, ViewChild, ElementRef, Component, OnInit, HostListener, OnDestroy, inject } from '@angular/core';
import { isPlatformBrowser, NgClass, AsyncPipe } from '@angular/common';
import { Router, Event, NavigationEnd, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartItem } from '../../model/cartItem';
import { AuthService } from '../../services/auth.service';
import { MobileMenuService } from '../../services/mobile-menu.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { SearchService } from '../../services/search.service';
import { sleep } from '../../utils';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { ShopMenuComponent } from '../shop-menu/shop-menu.component';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { ImgSrcSetDirective } from '../../directives/img-src-set.directive';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [TopBarComponent, RouterLink, ShopMenuComponent, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, ImgSrcSetDirective, NgClass, FormsModule, AsyncPipe]
})
export class HeaderComponent implements OnInit, OnDestroy {
  private platformId = inject<Record<string, unknown>>(PLATFORM_ID);
  private router = inject(Router);
  auth = inject(AuthService);
  mobileMenuService = inject(MobileMenuService);
  shoppingCartService = inject(ShoppingCartService);
  searchService = inject(SearchService);


  @ViewChild('searchInput') searchInputField: ElementRef;
  @ViewChild('searchInputFixed') searchInputFixedField: ElementRef;
  showFixedHeader = false;
  aboutUsMenuShown = false;
  adminMenuShown = false;
  mobileSearchBoxShown = false;
  term = '';
  currentPage: Record<string, boolean> = {};

  subscription: Subscription;
  termSubscription: Subscription;

  constructor() {
    const router = this.router;

    this.subscription = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentPage.adminManageStock = event.url.includes('/admin/stock-list');
        this.currentPage.adminManageImages = event.url.includes('/admin/image-list');
        this.currentPage.adminOrders = event.url.includes('/admin/orders');
        this.currentPage.adminOverview = event.url.includes('/admin/overview');
        this.mobileSearchBoxShown = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.toggleFixedHeader();
  }

  ngOnInit(): void {
    this.shoppingCartService.get();
    this.termSubscription = this.searchService.term$.subscribe(term => {
      this.term = term;
    });
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
    if(this.termSubscription) {
      this.termSubscription.unsubscribe();
    }
  }

  search(): void {
    this.searchService.navigate(this.term);
  }

  handleKeyUp($event): void {
    if($event.keyCode === 13){
      this.search();
    }
  }

  public async focusSearch(): Promise<void> {
    if(this.mobileSearchBoxShown) {
      if(this.showFixedHeader) {
        await sleep(200);
        this.searchInputFixedField.nativeElement.focus();
      } else {
        await sleep(200);
        this.searchInputField.nativeElement.focus();
      }
    }
  };

  removeFromCart(cartItem: CartItem): void {
    this.shoppingCartService.removeFromCart(cartItem);
  }

  private toggleFixedHeader = function(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.pageYOffset > 125) {
        this.showFixedHeader = true;
      } else if (window.pageYOffset <= 35) {
        this.showFixedHeader = false;
      }
    }
  };
}
